export const buildMatchId = (homeTeam, awayTeam, utcDate) => {
    const date = new Date(utcDate);
    const formatted = date.toLocaleDateString('en-GB', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        timeZone: 'Europe/London'
    });
    return `${homeTeam}-${awayTeam}-${formatted}`;
}